module.exports = __webpack_public_path__ + "static/img/mobile_hwaqapp_bg_banner.66caf25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_hwaqapp_bg_banner.png
// module id = /xgX
// module chunks = 21